import { atom } from 'jotai';
// Current authenticated user (null when logged out)
export const authUserAtom = atom(null);
// Auth state ready (firebase initialized and first onAuthStateChanged fired)
export const authReadyAtom = atom(false);
// Global auth modal visibility
export const authModalOpenAtom = atom(false);
